module.exports = __webpack_public_path__ + "a8177e5fcc61e98c65c99de678837917.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/scissors-s.png
// module id = 2114
// module chunks = 0